var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgElementFile = function SvgElementFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08 9.25C2.08 5.29012 5.29012 2.08 9.25 2.08H20.75C24.7099 2.08 27.92 5.29012 27.92 9.25V20.75C27.92 24.7099 24.7099 27.92 20.75 27.92H9.25C5.29012 27.92 2.08 24.7099 2.08 20.75V9.25Z",
    stroke: "#343A40",
    strokeWidth: 1.66
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.75H22.5",
    stroke: "#343A40",
    strokeWidth: 1.66,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5H22.5",
    stroke: "#343A40",
    strokeWidth: 1.66,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgElementFile);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMDggOS4yNUMyLjA4IDUuMjkwMTIgNS4yOTAxMiAyLjA4IDkuMjUgMi4wOEgyMC43NUMyNC43MDk5IDIuMDggMjcuOTIgNS4yOTAxMiAyNy45MiA5LjI1VjIwLjc1QzI3LjkyIDI0LjcwOTkgMjQuNzA5OSAyNy45MiAyMC43NSAyNy45Mkg5LjI1QzUuMjkwMTIgMjcuOTIgMi4wOCAyNC43MDk5IDIuMDggMjAuNzVWOS4yNVoiIHN0cm9rZT0iIzM0M0E0MCIgc3Ryb2tlLXdpZHRoPSIxLjY2Ii8+CjxwYXRoIGQ9Ik03LjUgMTguNzVIMjIuNSIgc3Ryb2tlPSIjMzQzQTQwIiBzdHJva2Utd2lkdGg9IjEuNjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuNSAxMi41SDIyLjUiIHN0cm9rZT0iIzM0M0E0MCIgc3Ryb2tlLXdpZHRoPSIxLjY2IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";